module.exports = __webpack_public_path__ + "static/img/jianting.e420733.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bottom/blue/jianting.png
// module id = UlQY
// module chunks = 24